import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { HistoryRes } from 'shared/types/general.types'
import { AuthContext } from 'store'

export const useFetchRentalHistory = () => {
	const params = useParams()
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const { data: rentalHistory, isPending: isRentalHistoryLoading } = useQuery<HistoryRes>({
		queryKey: queryKeys.rentals.history(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.rentalHistory(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		rentalHistory,
		isRentalHistoryLoading
	}
}
